var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { PerfilService } from '../../services/perfil.service';
import { ServiceException } from '../../model/exception';
var PerfilPopupComponent = (function () {
    function PerfilPopupComponent(_pflService, _comService) {
        this._pflService = _pflService;
        this._comService = _comService;
        this.onClose = new EventEmitter(false);
        this.visible = false;
        this.perfil = { id: 0, descr: "", codigo: "", activo: "", act: 1, permisos: [] };
        this.esModoAlta = true;
        this.key = "id";
        this.keepSorted = true;
        this.itemSelected = null;
        this.sorter = function (a, b) { return (a.descripcion < b.descripcion) ? -1 : ((a.descripcion > b.descripcion) ? 1 : 0); };
    }
    PerfilPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hideErrorMsg();
        this._comService.findFuncionalidades().subscribe(function (response) {
            _this.permisosIni = response;
            _this.permisosIni.sort(_this.sorter);
            if (typeof _this.permisosAgregados !== 'undefined') {
                _this.permisosAgregados = [];
            }
        });
    };
    PerfilPopupComponent.prototype.ngOnDestroy = function () {
        this.permisosIni = [];
        this.permisosAgregados = [];
        this.perfil = { id: 0, descr: "", codigo: "", activo: "", act: 1, permisos: [] };
    };
    PerfilPopupComponent.prototype.loadPfl = function (pfl) {
        var _this = this;
        this.esModoAlta = false;
        this.titulo = "EDICIÓN DE PERFIL";
        this.subtitulo = "Modifique los datos para editar el perfil";
        //this.perfil = pfl;
        //this.visible = true;
        this._pflService.findPfl(pfl.id).subscribe(function (response) {
            _this.perfil = response;
            _this.visible = true;
            _this.permisosAgregados = [];
            _this.actualizarPermisosIni();
        });
    };
    PerfilPopupComponent.prototype.newPfl = function () {
        this.esModoAlta = true;
        this.permisosAgregados = [];
        this.perfil = { id: 0, descr: "", codigo: "", activo: "", act: 1, permisos: [] };
        this.titulo = "NUEVO PERFIL";
        this.subtitulo = "Complete los datos para dar de alta al nuevo Perfil";
        this.visible = true;
    };
    PerfilPopupComponent.prototype.finalize = function () {
        this.visible = false;
        this.perfil = null;
        this.ngOnInit();
        this.permisosAgregados = [];
    };
    PerfilPopupComponent.prototype.onClickSave = function () {
        var _this = this;
        //this.usuario.usr_aud = KeycloakService.getLoggedUser();         
        this.perfil.permisos = this.permisosAgregados;
        this.perfil.act = 1;
        this.hideErrorMsg();
        //console.log("-> Perfil:  " + JSON.stringify(this.perfil));
        if (this.validate()) {
            if (this.esModoAlta) {
                this._pflService.insert(JSON.stringify(this.perfil)).subscribe(function (response) {
                    _this.perfil = response;
                    //console.log("ID PERFIL GENERADO: " + this.perfil.id);
                    _this.esModoAlta = false;
                    _this.onClose.emit(1);
                    _this.showSuccessMessage("El Perfil se ingreso correctamente");
                    document.getElementById('_buttonCancel').click();
                }, function (error) {
                    var exc = ServiceException.parse(error.json());
                    //console.log(exc.toString());
                    _this.showErrorMessage(exc.description);
                });
            }
            else {
                this._pflService.update(JSON.stringify(this.perfil)).subscribe(function (response) {
                    _this.perfil = response;
                    _this.onClose.emit(1);
                    _this.showSuccessMessage("El Perfil se modifico correctamente");
                    document.getElementById('_buttonCancel').click();
                }, function (error) {
                    var exc = ServiceException.parse(error.json());
                    //console.log(exc.toString());
                    _this.showErrorMessage(exc.description);
                });
            }
        }
    };
    PerfilPopupComponent.prototype.onClickCancelar = function () {
        this.onClose.emit(1);
    };
    PerfilPopupComponent.prototype.validate = function () {
        // if (this.perfil.codigo == ""){
        //      this.showErrorMessage("El Nombre de Usuario no puede ser vacío");
        //      return false;
        // }
        return true;
    };
    PerfilPopupComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    PerfilPopupComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    PerfilPopupComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    PerfilPopupComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    PerfilPopupComponent.prototype.findItemIndex = function (list, item, key) {
        if (key === void 0) { key = 'id'; }
        var idx = -1;
        // Assumption is that the arrays do not have duplicates.
        list.filter(function (e) {
            if (e.id === item[key]) {
                idx = list.indexOf(e);
                return true;
            }
            return false;
        });
        return idx;
    };
    PerfilPopupComponent.prototype.addItem = function (item) {
        if (item === void 0) { item = null; }
        var i = 0;
        if (item === null && this.itemSelected === null)
            return;
        if (item) {
            i = this.findItemIndex(this.permisosIni, item);
        }
        else {
            item = this.itemSelected;
            i = this.findItemIndex(this.permisosIni, item);
        }
        if (i !== -1) {
            this.permisosIni.splice(i, 1);
        }
        i = this.findItemIndex(this.permisosAgregados, item);
        if (i === -1) {
            this.permisosAgregados.push(item);
        }
        this.permisosAgregados.sort(this.sorter);
        this.itemSelected = null;
    };
    PerfilPopupComponent.prototype.rmvItem = function (item) {
        if (item === void 0) { item = null; }
        var i = 0;
        if (item === null && this.itemSelected === null)
            return;
        if (item) {
            i = this.findItemIndex(this.permisosAgregados, item);
        }
        else {
            item = this.itemSelected;
            i = this.findItemIndex(this.permisosAgregados, item);
        }
        if (i !== -1) {
            this.permisosAgregados.splice(i, 1);
        }
        i = this.findItemIndex(this.permisosIni, item);
        if (i === -1) {
            this.permisosIni.push(item);
        }
        this.permisosIni.sort(this.sorter);
        this.itemSelected = null;
    };
    PerfilPopupComponent.prototype.isItemSelected = function (item) {
        if (item === this.itemSelected) {
            return true;
        }
        return false;
    };
    PerfilPopupComponent.prototype.selectItem = function (item) {
        this.itemSelected = item;
    };
    PerfilPopupComponent.prototype.addAll = function () {
        this.permisosAgregados = this.permisosAgregados.concat(this.permisosIni);
        this.permisosIni.splice(0, this.permisosIni.length);
        this.permisosAgregados.sort(this.sorter);
    };
    PerfilPopupComponent.prototype.rmvAll = function () {
        this.permisosIni = this.permisosIni.concat(this.permisosAgregados);
        this.permisosAgregados.splice(0, this.permisosAgregados.length);
        this.permisosIni.sort(this.sorter);
    };
    PerfilPopupComponent.prototype.actualizarPermisosIni = function () {
        var len = this.perfil.permisos.length;
        for (var i = 0; i < len; i++) {
            this.addItem(this.perfil.permisos[i]);
        }
    };
    PerfilPopupComponent.prototype.isAllSelected = function (source) {
        if (source.length === 0) {
            return true;
        }
        return false;
    };
    PerfilPopupComponent.prototype.isSelectedItem = function () {
        if (this.itemSelected == null) {
            return false;
        }
        return true;
    };
    PerfilPopupComponent.prototype.isAnySelected = function (source) {
        if (source.length > 0) {
            return true;
        }
        return false;
    };
    return PerfilPopupComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PerfilPopupComponent.prototype, "onClose", void 0);
PerfilPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'perfil-popup',
        templateUrl: 'perfil-popup.component.html'
    }),
    __metadata("design:paramtypes", [PerfilService,
        CommonService])
], PerfilPopupComponent);
export { PerfilPopupComponent };
//# sourceMappingURL=perfil-popup.component.js.map